export default {
  fontSize: '16px',
  baseLineHeight: '150%',
  borderRadius: '0.25rem',
  fontFamily: 'Arial',
  fontWeight: '400',
  fontColor: '#555',

  backgroundColor: 'white',
  primaryColor: 'black',

  grayColor: 'grey',
  grayLightColor: 'lightgrey',
  grayDarkColor: 'darkgrey',
  gray01: '#f3f4f7',

  h1Color: 'black',
  h2Color: 'black',
  h3Color: 'black',

  grid: {
    containerGap: '1rem',
    columnGap: '2rem',
  },

  breakingpoints: {
    never: '0',
    start: '0',
    xs: '0',
    sm: '36rem',
    md: '48rem',
    lg: '62rem',
    xl: '75rem',
    always: '9999rem',
  },
};
